import $ from 'jquery';

Drupal.behaviors.troaxMenuToggles = {
  attach() {
    $('body')
      .once('troaxMenuToggles')
      .each((index, element) => this.menuBehavior(element));
  },

  // Grab elements we need and initiate event listeners
  menuBehavior() {
    localStorage.setItem('mega-menu', 'closed');
    localStorage.setItem('market-list', 'closed');
    localStorage.setItem('search-form', 'closed');

    // Get window
    const $window = $(window);

    // Header constants
    const header = $('header.header');
    const headerWrapper = $('.header-wrapper');
    const headerIcon = $('.header__navigations-icon');
    const mobileSearchIcon = $('.mobile-search-icon');
    const mobileSearchCloseIcon = $('.mobile-search-close-icon');
    const mobileSearch = $('.mobile-search');
    const searchIcon = $('.header__search .icon');
    const searchForm = $('.header-search-form');
    const searchFormInput = $('.header-search-form .form-text');

    // Mega Menu constants
    const megaMenu = $('.mega-menu');
    const contentWrapper = $('.mega-menu__content-wrapper');

    // Market variables
    const marketIcon = $('.market-selector');
    const marketList = $('.mega-menu__market-list');

    // Scrolling behavior for Responsive devices
    function preventResponsiveScrolling() {
      $('body').addClass('resp-no-scroll');
    }

    function addResponsiveScrolling() {
      $('body').removeClass('resp-no-scroll');
    }

    function setHeaderIcon() {
      const mmStatus = localStorage.getItem('mega-menu') ? localStorage.getItem('mega-menu') : 'closed';

      if (mmStatus === 'open') {
        headerIcon.addClass('header-icon--open');
        headerIcon.removeClass('header-icon--close');
        preventResponsiveScrolling();
      } else {
        headerIcon.addClass('header-icon--close');
        headerIcon.removeClass('header-icon--open');
        addResponsiveScrolling();
      }
    }


    function toggleMegaMenu() {
      const sfStatus = localStorage.getItem('search-form') ? localStorage.getItem('search-form') : 'closed';

      // Hide marketList and show contentWrapper initially
      marketList.removeClass('mega-menu__market-list--open');
      contentWrapper.removeClass('mega-menu__content-wrapper--hidden');

      // Toggle header and mega menu
      if (sfStatus === 'open') {
        header.addClass('header--open');
        megaMenu.toggleClass('mega-menu--open');
        searchFormInput.focus().select();
      } else {
        headerWrapper.toggleClass('header-wrapper--open');
        header.toggleClass('header--open');
        megaMenu.toggleClass('mega-menu--open');
      }

      // Save mega menu status to local storage
      if (megaMenu.hasClass('mega-menu--open')) {
        localStorage.setItem('mega-menu', 'open');
      } else {
        localStorage.setItem('mega-menu', 'closed');
        localStorage.setItem('market-list', 'closed');
        if (sfStatus === 'closed') {
          header.removeClass('header--open');
        }
      }

      setHeaderIcon();
    }

    function toggleMarkets(event) {
      const mmStatus = localStorage.getItem('mega-menu') ? localStorage.getItem('mega-menu') : 'closed';
      const mlStatus = localStorage.getItem('market-list') ? localStorage.getItem('market-list') : 'closed';
      event.stopPropagation();

      if (mmStatus === 'open' && mlStatus === 'closed') {
        contentWrapper.addClass('mega-menu__content-wrapper--hidden');
        marketList.addClass('mega-menu__market-list--open');
        localStorage.setItem('market-list', 'open');
      } else if (mmStatus === 'open' && mlStatus === 'open') {
        contentWrapper.addClass('mega-menu__content-wrapper--hidden');
        marketList.removeClass('mega-menu__market-list--open');
        localStorage.setItem('market-list', 'closed');
        localStorage.setItem('mega-menu', 'closed');
        toggleMegaMenu();
      } else {
        if (header.hasClass('header--up')) {
          header.addClass('header--down');
          header.removeClass('header--up');
        }

        toggleMegaMenu();
        contentWrapper.addClass('mega-menu__content-wrapper--hidden');
        marketList.addClass('mega-menu__market-list--open');
        localStorage.setItem('market-list', 'open');
      }
    }

    function closeOnClickOutsideMenu() {
      if (headerIcon.hasClass('header-icon--open')) {
        localStorage.setItem('mega-menu', 'closed');
        headerIcon.addClass('header-icon--close');
        headerIcon.removeClass('header-icon--open');
        megaMenu.toggleClass('mega-menu--open');
        headerWrapper.removeClass('header-wrapper--open');
        header.toggleClass('header--open');
        addResponsiveScrolling();
      }
    }

    function toggleSearch(event) {
      event.stopPropagation();
      const mmStatus = localStorage.getItem('mega-menu') ? localStorage.getItem('mega-menu') : 'closed';

      if (mmStatus === 'open') {
        searchForm.toggleClass('header-search-form--open');
      } else {
        headerWrapper.toggleClass('header-wrapper--open');
        header.addClass('header--open');
        searchForm.toggleClass('header-search-form--open');
      }

      // Save search field status to local storage
      if (searchForm.hasClass('header-search-form--open')) {
        localStorage.setItem('search-form', 'open');
      } else {
        if (mmStatus === 'closed') {
          header.removeClass('header--open');
        }
        localStorage.setItem('search-form', 'closed');
      }
      searchFormInput.focus().select();
    }

    function toggleMobileSearch(event) {
      event.stopPropagation();
      const mmStatus = localStorage.getItem('mega-menu') ? localStorage.getItem('mega-menu') : 'closed';

      if (mmStatus === 'open') {
        searchForm.toggleClass('header-search-form--open');
        header.removeClass('header--open');
        mobileSearch.toggleClass('mobile-search--open');
        mobileSearchIcon.toggleClass('mobile-search-icon--open');
      } else {
        headerWrapper.toggleClass('header-wrapper--open');
        header.addClass('header--open');
        searchForm.toggleClass('header-search-form--open');
        mobileSearch.toggleClass('mobile-search--open');
        mobileSearchIcon.toggleClass('mobile-search-icon--open');
      }

      // Save search field status to local storage
      if (searchForm.hasClass('header-search-form--open')) {
        localStorage.setItem('search-form', 'open');
      } else {
        if (mmStatus === 'closed') {
          header.removeClass('header--open');
        }
        localStorage.setItem('search-form', 'closed');
      }
      searchFormInput.focus().select();
    }


    function stopProp(e) {
      e.stopPropagation();
    }

    // Events
    searchIcon.on('click', toggleSearch);
    mobileSearchIcon.on('click', toggleMobileSearch);
    mobileSearchCloseIcon.on('click', toggleMobileSearch);
    headerIcon.on('click', toggleMegaMenu);
    marketIcon.on('click', toggleMarkets);
    $window.on('click', closeOnClickOutsideMenu);
    headerWrapper.on('click', stopProp);
    megaMenu.on('click', stopProp);
  },
};
